<template>
  <div>
    <div class="threeColumnGrid">
    <tl-select
          label="Mode of Payment"
          :options="['Cheque', 'DD', 'Transfer', 'Digital Wallet']"
          :value="bank.paymentType"
          @change="(val)=>paymentmode(val)"
        />
         <!-- <txt v-if="paymentType == 'Digital Wallet'" label='UPI Address' 
           type="text"></txt> -->
      </div>
    <br>
    <div class="threeColumnGrid" v-if="showbankdetails">
     <txt label='Account Holder’s Name' type="text" v-model="bank.account_holder_name"></txt>
      <txt label='Account Number' type="number" v-validate="'required'" name="AccountNumber" :classname="errors.has('AccountNumber')" :errormsg="errors.first('AccountNumber')" v-model="bank.account_number"></txt>
      <tl-select label="Account type" 
          :options="['Personal', 'Joint']"
          v-model="bank.account_type"/>
      <txt 
        label='Bank Name' 
        type="text"
        name="bankName" 
        v-validate="'required'" 
        v-model="bank.bank_name"
        :classname="errors.has('bankName')"
        :errormsg="errors.first('bankName')"
        ></txt>
      <txt label='IFSC Code' type="text" name="IFSCCode" :classname="errors.has('IFSCCode')" :errormsg="errors.first('IFSCCode')" v-model="bank.ifsc_code"></txt>
      <tl-select label="Type of Bank Transfer"
          :options="['NEFT', 'RTGS', 'IMPS']"
          v-model="bank.bank_transfer_type"/>
      <txt label='MICR' type="number" v-maxchars="9" v-model="bank.micr"></txt>
      <div></div>
      <!-- <div class="link" v-on:click="customreport">Delete Account</div> -->
    </div>
    <br>
    <!-- <div class="link" v-on:click="customreport">Add Another Account</div> -->
    <br>
    <!-- <tl-checkbox
        label="Same Account for FBP"
        v-model="sameAccFBP"
        /> -->
         <tl-checkbox
          label="Same Account For FBP?"
          v-model="bank.same_acc_fbp"
          @change="(val)=>bank.same_acc_fbp=val"
          >
      </tl-checkbox>
      <!-- {{sameAccFBP}}  -->
    <br>
    <div class="threeColumnGrid" v-if="!bank.same_acc_fbp">
      <txt label='Account Holder’s Name' type="text" v-model="bank.fbp.account_holder_name"></txt>
      <txt label='Account Number' type="number" v-model="bank.fbp.account_number"></txt>
      <tl-select label="Account type" 
          :options="['Personal', 'Joint']"
          v-model="bank.fbp.account_type"/>
      <txt label='Bank Name' type="text" v-model="bank.fbp.bank_name"></txt>
      <txt label='IFSC Code' type="text" v-model="bank.fbp.ifsc_code"></txt>
      <tl-select label="Type of Bank Transfer"
          :options="['NEFT', 'RTGS', 'IMPS']"
          v-model="bank.fbp.bank_transfer_type"/>
      <txt label='MICR' type="text" v-model="bank.fbp.micr" ></txt>
      <div></div>
      <!-- <div class="link" v-on:click="customreport">Delete Account</div> -->
    </div>
  </div>
</template>

<script>
// import {  mapActions } from "vuex";
export default {
  data() {
    return {
      // same_acc_fbp: true,
      paymentType: null,
      showbankdetails:true,
      bank:{
        same_acc_fbp: true,
        fbp:{}
      }
    }
  },
  watch:{
      bank: function(val) {
          // //console.log('bankinfo',val)
          this.$emit('bankinfo',val)
        },
     deep: true
    },
  methods:{
    paymentmode(val){
      this.paymentType=val
      // //console.log('paymentmode',val)
      // if(this.paymentType=='Digital Wallet'){
      //   this.showbankdetails=false
      // }else{
      //    this.showbankdetails=true
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.radio-container {
  display: flex;
  flex-direction: column;
  margin: 25px 0px 25px 0px;
  color: #404040;
  font-size: $font-size-small;
  *:nth-child(n) {
    margin-bottom: 10px;
  }
}
.radio-btn {
  display: flex;
  *:nth-child(n) {
    margin-right: 20px;
  }
}

  .link {
    color: #5d409f;
    font-size: 12px;
    text-decoration: underline;
    padding-top: 10px;
    cursor: pointer;
  }
</style>
